import { ISchedule } from '../schedule';
import { ISession, SingleCommunication } from '../session';

export enum Variant {
  A = 'A',
  B = 'B',
  C = 'C'
}

export interface IEpxHeartSchedule extends ISchedule {
  variant?: Variant;
  previousMode?: 'W' | 'D';
  hasScale?: boolean;
  askBloodPressure?: boolean;
  shouldUseKCCQ?: boolean;
}

type TriState = -1 | 0 | 1;

export interface IEpxHeart
  extends ISession<IEpxHeartSchedule>, SingleCommunication {
  variant?: Variant;
  // Regular
  dpe?: TriState;
  isRecheck?: boolean;
  isWeight?: boolean;
  orthopnea?: TriState;
  hasExcessiveWeightGain?: boolean;
  weight?: number;
  // KCCQ
  isKCCQ?: boolean;
  kPhysical?: number;
  isPAHindered?: boolean;
  // BP
  isBP?: boolean;
  bpUpper?: number;
  bpLower?: number;
  // Other
  isSOBSymptoms: boolean;
  hasSOBAwakened?: boolean;
  lyingDownSOB?: number;
  // Variant A
  dyspnea?: TriState;
  edema?: TriState;
  // Variant B
  wantsToSpeak?: boolean;
  // Binary
  isBinary?: boolean;
}

export type IEpxHeartRaw = IEpxHeart & {
  weightDecimal?: number;
};
